import { Notifications } from "../notifications";
export function showInputError(input, message) {
    Notifications.error(message);
    input.parentElement.classList.add("has-warning");
}
